import { motion } from "framer-motion";
import { TEAM } from "../data/content";

export const Team = () => (
  <section id="kadromuz" data-testid="team-section" className="bg-[#16281D] py-24 md:py-36 text-[#F8F7F4]">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
      <div className="lg:col-span-4">
        <div className="lg:sticky lg:top-32">
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-xs uppercase tracking-[0.3em] font-bold text-[#D4A373] mb-5"
          >
            {TEAM.overline}
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
            className="font-serif font-light text-3xl md:text-5xl tracking-tight leading-tight"
          >
            Sizin için burada olan <em className="italic text-[#D4A373]">ekibimiz</em>
          </motion.h2>
        </div>
      </div>

      <div className="lg:col-span-8">
        {TEAM.members.map((m, i) => (
          <motion.div
            key={m.no}
            data-testid={`team-member-${i}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
            className={`group grid grid-cols-12 gap-6 py-10 md:py-14 items-center ${i !== 0 ? "border-t border-[#F8F7F4]/10" : ""}`}
          >
            <span className="col-span-12 md:col-span-3 font-serif text-5xl md:text-7xl font-light text-[#D4A373]/50 group-hover:text-[#D4A373] transition-colors duration-500">
              {m.no}
            </span>
            <div className="col-span-12 md:col-span-9">
              <h3 className="font-serif text-2xl md:text-4xl mb-3">{m.name}</h3>
              <p className="text-xs uppercase tracking-[0.25em] font-bold text-[#F8F7F4]/50">{m.role}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
